import React from "react";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
class guildServicePrices extends React.Component {
  state = {
    VendorHeader: true,
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        <GlobalStyles />
        <Header
          showSearchBar={true}
          title={"قیمت اتحادیه"}
          VendorHeader={this.state.VendorHeader}
        />
        {this.props.location.guildServicePrices.guild_service_prices.map(
          (item) => (
            <div className="guildServicePricesCom">
              <div className="guildServicePricesComDetails">
                <div className="guildServicePricesComDetailsTitle">
                  {item.service.title}
                </div>
                <div className="left">
                  <span className="priceText">قیمت :</span>
                  <span className="priceNum">
                    {item.service.price}
                    <span className="priceNum">تومان</span>
                  </span>
                </div>
              </div>
            </div>
          ),
        )}
      </>
    );
  }
}
export default guildServicePrices;
